import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Link } from 'react-router-dom';

const ListItem = ({ icon: Icon, label, value, color }) => {
  return (
    <div className="flex items-center justify-between py-1 rounded">
      <div className="flex items-center gap-3">
        <Icon className={`h-4 w-4 ${color}`} />
        <span className="text-sm text-muted-foreground">{label}</span>
      </div>
      <span className="text-sm font-bold">{value}</span>
    </div>
  );
};

export function DashboardListSection({ title, linkTo, linkText = 'View all', items }) {
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between pb-3">
        <CardTitle className="text-lg font-semibold">{title}</CardTitle>
        {linkTo && (
          <Link to={linkTo} className="text-sm text-primary hover:underline">
            {linkText}
          </Link>
        )}
      </CardHeader>
      <CardContent>
        {items.map((item, index) => (
          <ListItem
            key={index}
            icon={item.icon}
            label={item.label}
            value={item.value}
            color={item.color}
          />
        ))}
      </CardContent>
    </Card>
  );
}
